/**
 * DI-3-E — `POST …/data-acquisitions/{id}/intake/withdraw {reason}` (intake/v1
 * 1.10.0, DI-3-B §2.3, N11 "Withdraw this data set"). The reason is REQUIRED,
 * 3–500 characters (the contract's `minLength` / `maxLength`); the dialog
 * keeps the button disabled outside that range, the gateway refuses it too.
 * 200 → the set is REJECTED + deleted under a withdrawn placeholder
 * instruction; the original instruction is free at once.
 */
import { intakeFetch } from "./intakeFetch.js";
import type { WithdrawResult } from "./intakeTypes.js";

export const WITHDRAW_REASON_MIN = 3;
export const WITHDRAW_REASON_MAX = 500;

/** The trimmed reason, or null when it is outside 3–500 characters. */
export function validWithdrawReason(reason: string): string | null {
  const t = reason.trim();
  return t.length >= WITHDRAW_REASON_MIN && t.length <= WITHDRAW_REASON_MAX
    ? t
    : null;
}

export function withdrawIntake(
  daId: string,
  reason: string,
): Promise<WithdrawResult> {
  return intakeFetch<WithdrawResult>(
    `/data-acquisitions/${encodeURIComponent(daId)}/intake/withdraw`,
    { method: "POST", body: { reason } },
  );
}
